import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material';
import { CookieService } from 'ngx-cookie-service';
import { CustomErrorStateMatcher } from 'src/app/error-state-matcher/error-state.matcher';
import { AddressAddition, AddressSuccess } from 'src/app/models/address';
import { ApiResponse } from 'src/app/models/cart';
import { AddressService } from 'src/app/services/checkout-services/address.service';
import { FormControl, FormGroupDirective, NgForm } from "@angular/forms";

export interface CancelEvent{
  "addressType":string;
  "showForm":boolean;
}

@Component({
  selector: 'app-add-address-form',
  templateUrl: './add-address-form.component.html',
  styleUrls: ['./add-address-form.component.scss'],
  providers:[
    {
      provide:ErrorStateMatcher,
      useClass:CustomErrorStateMatcher
    }
  ]
})


export class AddAddressFormComponent implements OnInit {
  form:FormGroup;
  pattern2 = 'return /[a-z]/i.test(event.key)'
  pattern3 = '^[0-9_-]{10,11}';
  pattern1 = "^[0-9_-]{6,7}";
  NewInfo=new AddressAddition();
  customErrorStateMatcher = new CustomErrorStateMatcher();
  @Input()
  addressType:string;
  @Output()
  addressSuccess:EventEmitter<ApiResponse<AddressSuccess>>= new EventEmitter<ApiResponse<AddressSuccess>>();
  @Output()
  addressCancel:EventEmitter<CancelEvent>= new EventEmitter<CancelEvent>();

  @ViewChild('saved',{read:ElementRef, static:true}) save;

  constructor(private fb:FormBuilder, private addressService:AddressService, private _cookie:CookieService) { }

  ngOnInit() {
    this.form = this.fb.group({
      pinCode: ['', [Validators.required, Validators.pattern(this.pattern1)]],
      address: ['', Validators.required],
      city: ['',[Validators.required]],
      name: ['', Validators.required],
      number: ['', [Validators.required, Validators.pattern(this.pattern3)]],
      state: ['', Validators.required],
      alt: ['', Validators.pattern(this.pattern3)],
      gst:[''],
      locality: [''],
      type: ['']
    });
    this.NewInfo.alternateContactNumber = '';
    this.NewInfo.landmark = '';
    this.NewInfo.gst = '';
  }

  
  saveAddress(){
    this.form.markAllAsTouched()
    this.save.nativeElement.click();
    this.addAddress();
  }

  addAddress() {
    this.form.markAllAsTouched();
    if (this.form.valid) {
      this.NewInfo.type=this.addressType;
      this.NewInfo.pincode = this.NewInfo.pincode.toString();
      this.NewInfo.contactNumber = this.NewInfo.contactNumber.toString();
      
      if (this.NewInfo.alternateContactNumber) {
        this.NewInfo.alternateContactNumber = this.NewInfo.alternateContactNumber.toString();
      }
      this.NewInfo.type=this.addressType;
      if(this.NewInfo.landmark==null){
        this.NewInfo.landmark=="";
      }
      
      this.addressService.addAddress(this.NewInfo, this._cookie.get('UserID'), this._cookie.get('Authorization')).subscribe(data => {
        this.addressSuccess.emit(data);
      });
      this.NewInfo = new AddressAddition();
      this.NewInfo.landmark='';
      this.NewInfo.state = '';
      this.form.reset();
    }
  }
  cancel(){
    this.form.reset();

    this.addressCancel.emit({"addressType":this.addressType,"showForm":false});
  }

}
